'use strict';

window.addEventListener('DOMContentLoaded', (event) => {

  /**
   * selected frame variant
   */
  const frameSelection = document.querySelector('.variant_frame_name');

  if (frameSelection !== null) {
    frameSelection.addEventListener('click', (e) => {
      const frame_result = document.querySelector('.frame_value');
      frame_result.textContent = `${e.target.value}`;

      if (e.target.value == undefined) {
        frame_result.textContent = ` `;
      }
    });
  }

  /**
   * Product specs
   */
  const productTitle = document.querySelectorAll('.product-description-title');

  if (productTitle !== null) {
    productTitle.forEach((btn) => {
      const productData = document.querySelectorAll('.product-description-content');

      btn.addEventListener('click', (e) => {
        productData.forEach((content) => {
          if (e.target.nextElementSibling !== content && content.classList.contains('active')) {
            content.classList.remove('active');
            productTitle.forEach((btn) => btn.classList.remove('active'));
          }
        });
        const container = btn.nextElementSibling;
        container.classList.toggle('active');
        btn.classList.toggle('active');
      });
    });
  }

  /**
   * Product select variant
   */
  const selectLabel = document.querySelector('#select-variant');
  const selectArrow = document.querySelector('.arrow-down'); // define selectArrow here

  if (selectLabel !== null) {
    const dropdown = function () {
      const optionVariants = document.querySelector('.variant_options');

      optionVariants.classList.toggle('toggle-variant');
      selectArrow.classList.toggle('toggle-variant');
      selectLabel.classList.toggle('toggle-variant');
    };

    selectLabel.addEventListener('click', dropdown);

    // Listen for clicks on the options
    const variantOptions = document.querySelector('.variant_options');
    if (variantOptions !== null) {
      variantOptions.addEventListener("click", function (event) {
        // If an option was clicked (check with the class .product_option)
        if (event.target.matches('.product_variant')) {
          // Close the dropdown
          variantOptions.classList.toggle("toggle-variant");
          selectArrow.classList.toggle('toggle-variant'); // now selectArrow is defined
          selectLabel.classList.toggle("toggle-variant");
        }
      });
    } else {
      console.error("Could not find element with class '.variant_options'");
    }
  }


  /**
   * selected size variant
   */
  const optionSize = document.querySelector('.variant_options');

  if (optionSize !== null) {
    optionSize.addEventListener('click', (e) => {
      const result = document.querySelector('.selected-value');
      result.textContent = `Selected - ${e.target.value}`;

      if (e.target.value == undefined) {
        result.textContent = `Select`;
      }
    });
  }

  /**
   * selected no frame variant
   */
  const noSize = document.querySelector('.no_frame');
  const haveSize = document.querySelectorAll('.have_frame');
  const have_frame = document.querySelectorAll('.size');
  const no_frame = document.querySelectorAll('.size_no_frame');
  
  if (noSize) {
    const switchSize = function () {
      have_frame.forEach((item) => {
        item.classList.add('hide');
      });
      no_frame.forEach((item) => {
        item.classList.remove('hide');
      });
    };
    noSize.addEventListener('click', switchSize);
  }
  
  if (have_frame) {
    const switchFrame = function () {
      have_frame.forEach((item) => {
        item.classList.remove('hide');
      });
      no_frame.forEach((item) => {
        item.classList.add('hide');
      });
    };
  
    haveSize.forEach((item) => {
      item.addEventListener('click', switchFrame);
    });
  }
  

  function initObserver() {
    let targetNode = document.querySelector(".template-product #select-variant");
    let selectArrow = document.querySelector('.arrow-down'); // define selectArrow here

    if (targetNode) {
      let config = { childList: true, subtree: true };

      let callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // Try to find the element again
            const selectLabel = document.querySelector("#select-variant");
            const variantOptions = document.querySelector(".variant_options");

            if (selectLabel && variantOptions) {
              selectLabel.addEventListener("click", function () {
                variantOptions.classList.toggle("toggle-variant");
                selectArrow.classList.toggle('toggle-variant');
              });

              variantOptions.addEventListener("click", function (event) {
                if (event.target.matches('.product_option')) {
                  variantOptions.classList.toggle("toggle-variant");
                  selectArrow.classList.toggle('toggle-variant');
                  selectLabel.classList.toggle("toggle-variant");
                }
              });

              // Once found and event listeners added, there's no need to observe anymore.
              observer.disconnect();
            }
          }
        }
      };

      let observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }
  }


  // Start observing as soon as the page is fully loaded
  initObserver();
});

document.addEventListener('DOMContentLoaded', function() {
  var productJson = JSON.parse(document.getElementById('ProductJson-12345').textContent);
  var variantSelectors = document.querySelectorAll('[data-single-option-selector]');
  var addToCartButton = document.querySelector('[data-add-to-cart]');
  var productSelect = document.querySelector('[data-product-select]');
  var frameValueDisplay = document.querySelector('.frames.frame_value');



  var selectors = {
    productPrice: '[data-product-price]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    afterpayPrice: '[data-afterpay-price]',
    unitPriceWrapper: '[data-unit-price-wrapper]',
    unitPrice: '[data-unit-price]',
    unitPriceMeasurementReferenceUnit: '[data-unit-price-measurement-reference-unit]'
  };

  function updateAddToCartState(variant) {
    if (variant && variant.available) {
      addToCartButton.disabled = false;
      addToCartButton.querySelector('[data-add-to-cart-text]').textContent = "Add to bag";
    } else {
      addToCartButton.disabled = true;
      addToCartButton.querySelector('[data-add-to-cart-text]').textContent = "Out of stock";
    }
  }

  function updateProductPrices(variant) {
    if (!variant) return;

    // General price elements above the variants
    const priceContainer = document.querySelector('[data-product-price]');
    let priceToDisplay = variant.price;

    // If the discount is active, calculate the discounted price
    let discountedPrice = null;
    if (window.showDiscountPrice) {
        discountedPrice = priceToDisplay * 0.75; // Calculate 25% discount
    }

    // Update the price above the variant selector
    if (priceContainer) {
        if (discountedPrice !== null) {
            // Show both the discounted price and the original price
            priceContainer.innerHTML = `
                <span class="discounted-price">${Shopify.formatMoney(discountedPrice) + ' ' + Shopify.currency.active}</span>
                <span class="sale-bigprice" data-compare-price style="text-decoration:line-through; margin-left: 4px;">
                    ${Shopify.formatMoney(priceToDisplay)}
                </span>
            `;
        } else {
            // No discount, just show the original price
            priceContainer.innerHTML = `
                <span class="original-price">${Shopify.formatMoney(priceToDisplay) + ' ' + Shopify.currency.active}</span>
            `;
        }
    }

    // Updating the button prices (show only the discounted price or original price)
    const buttonPriceWrapper = document.querySelector('.price_toggle[data-price-wrapper]');
    if (buttonPriceWrapper) {
        if (discountedPrice !== null) {
            // Show only the discounted price in the button
            buttonPriceWrapper.innerHTML = `
                <span class="data-product-price">${Shopify.formatMoney(discountedPrice) + ' ' + Shopify.currency.active}</span>
            `;
        } else {
            // Show only the original price in the button if no discount is active
            buttonPriceWrapper.innerHTML = `
                <span class="data-product-price">${Shopify.formatMoney(priceToDisplay) + ' ' + Shopify.currency.active}</span>
            `;
        }
    }

    // Updating additional price elements (like afterpay, compare price, etc.)
    const afterpayPrice = document.querySelector(selectors.afterpayPrice);
    if (afterpayPrice) {
        afterpayPrice.innerHTML = Shopify.formatMoney(variant.price / 4);
    }

    const comparePrice = document.querySelector(selectors.comparePrice);
    const comparePriceText = document.querySelector(selectors.comparePriceText);
    if (comparePrice && comparePriceText) {
        if (variant.compare_at_price > variant.price) {
            comparePrice.innerHTML = Shopify.formatMoney(variant.compare_at_price);
            comparePrice.classList.remove("hide");
            comparePriceText.classList.remove("hide");
        } else {
            comparePrice.innerHTML = "";
            comparePrice.classList.add("hide");
            comparePriceText.classList.add("hide");
        }
    }

    // Update unit pricing if applicable
    updateUnitPricing(variant);
}


  function updateUnitPricing(variant) {
    const unitPriceContainer = document.querySelector(selectors.unitPriceWrapper);
    const unitPrice = document.querySelector(selectors.unitPrice);
    const unitPriceBaseUnit = document.querySelector(selectors.unitPriceMeasurementReferenceUnit);

    if (unitPriceContainer && unitPrice && unitPriceBaseUnit) {
      if (variant.unit_price) {
        unitPrice.innerHTML = Shopify.formatMoney(variant.unit_price);
        unitPriceBaseUnit.innerHTML = variant.unit_price_measurement.reference_unit;
        unitPriceContainer.classList.remove('hide');
      } else {
        unitPriceContainer.classList.add('hide');
      }
    }
  }

  function updateVariantId(variant) {
    if (variant && productSelect) {
      productSelect.value = variant.id;
    }
  }

  function getSelectedOptions() {
    var selectedOptions = [];
    variantSelectors.forEach(function(selector) {
      if (selector.tagName === 'SELECT') {
        selectedOptions.push(selector.value);
      } else if (selector.tagName === 'INPUT' && selector.type === 'radio' && selector.checked) {
        selectedOptions.push(selector.value);
      }
    });
    return selectedOptions;
  }

  function getSelectedVariant() {
    var selectedOptions = getSelectedOptions();
    return productJson.variants.find(function(variant) {
      return variant.options.every(function(option, index) {
        return option === selectedOptions[index];
      });
    });
  }
  function handleOptionChange(event) {
    var selectedVariant = getSelectedVariant();
    if (selectedVariant) {
      updateAddToCartState(selectedVariant);
      updateProductPrices(selectedVariant);
      updateVariantId(selectedVariant);
    }
  
    // Check if event.target exists and has the 'name' property
    if (event.target && event.target.name === 'frame' && frameValueDisplay) {
      frameValueDisplay.textContent = event.target.value || '';
    }
  }
  

  // Add event listeners to all variant selectors
  variantSelectors.forEach(function(selector) {
    if (selector.tagName === 'SELECT') {
      selector.addEventListener('change', handleOptionChange);
    } else if (selector.tagName === 'INPUT' && selector.type === 'radio') {
      selector.addEventListener('change', handleOptionChange);
    }
  });

  // Initial update
  handleOptionChange({ target: document.querySelector('[data-single-option-selector]:checked') || document.querySelector('[data-single-option-selector]') });
});

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('DOMContentLoaded', function() {
  console.log('Flickity carousel initialized');
  var flickityContainer = document.querySelector('.mobile-flickity'); // Select the Flickity container
  var flickitySlides = flickityContainer.querySelector('.mobile-flickity__slides'); // Select the slides
  var nextButton = flickityContainer.querySelector('.btn--next'); // Select the next button

  // Check if there are enough slides to enable wrapAround
  var noChildren = flickitySlides.children.length;
  var wrapAround = noChildren > 2;

  // Initialize Flickity
  var flickityInstance = new Flickity(flickitySlides, {
    freeScroll: true,
    watchCSS: true,
    wrapAround: wrapAround,
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    prevNextButtons: false, // We're using custom buttons
    pageDots: true,
    accessibility: false
  });

  // Set up a custom "next" button to advance the slides
  if (nextButton) {
    nextButton.addEventListener('click', function() {
      flickityInstance.next();
    });
  }

  // Handle iOS touch event bug fixes for dragging
  flickitySlides.addEventListener('dragStart.flickity', function() {
    document.ontouchmove = function(e) {
      e.preventDefault();
    };
  });

  flickitySlides.addEventListener('dragEnd.flickity', function() {
    document.ontouchmove = function(e) {
      return true;
    };
  });

  // If there's a selected element (like `.initial-selected`), start Flickity from that slide
  var initialSelected = flickitySlides.querySelector('.initial-selected');
  if (initialSelected) {
    var index = Array.from(flickitySlides.children).indexOf(initialSelected);
    flickityInstance.select(index);
  }

  // Handle Flickity state changes for accessibility (if needed)
  flickitySlides.addEventListener('change.flickity', function() {
    // If you need to manage focus or other accessibility-related changes, implement them here
  });
});
